import { jsxs as p, jsx as e, Fragment as v } from "react/jsx-runtime";
import { Root as x, Content as C, Anchor as A, Trigger as O } from "@radix-ui/react-popover";
import l from "react";
import c from "./index.es683.js";
import { MAP_BACKGROUND_OPTIONS as b } from "./index.es684.js";
import { useTheme as B } from "./index.es190.js";
import { PopoverTemplateBasicHeader as F } from "./index.es685.js";
import { PopoverTemplateBasicFooter as N } from "./index.es686.js";
const k = "popover-template", s = ({
  children: d,
  trigger: i,
  anchor: a,
  header: t,
  footer: r,
  zIndex: T,
  backgroundColor: n = "white",
  testId: o = k,
  align: f = "center",
  alignOffset: h = 0,
  side: P = "bottom",
  sideOffset: _ = 0,
  maxWidth: g,
  ...u
}) => {
  const { zIndexes: E } = B();
  let m = /* @__PURE__ */ e(v, {});
  return a && (m = /* @__PURE__ */ e(A, { "data-testid": o + "-anchor", children: a })), i && (m = /* @__PURE__ */ e(O, { asChild: !0, "data-testid": o + "-trigger", children: i })), /* @__PURE__ */ p(x, { ...u, children: [
    m,
    /* @__PURE__ */ p(
      C,
      {
        align: f,
        alignOffset: h,
        side: P,
        sideOffset: _,
        style: {
          zIndex: E.popover || T,
          backgroundColor: b[n],
          maxWidth: g || "none"
        },
        className: c.content,
        "data-testid": o + "-content",
        children: [
          t && l.cloneElement(t, {
            backgroundColor: t.props.backgroundColor ?? n,
            testId: o + "-header"
          }),
          /* @__PURE__ */ e("div", { className: c.contentBody, children: d }),
          r && l.cloneElement(r, {
            backgroundColor: r.props.backgroundColor ?? n,
            testId: o + "-footer"
          })
        ]
      }
    )
  ] });
};
s.Header = F;
s.Footer = N;
export {
  k as DEFAULT_POPOVER_TEMPLATE_TEST_ID,
  s as PopoverTemplate
};
//# sourceMappingURL=index.es161.js.map
